import { Types } from "../actions/PersonalSummaryActions";

const initialState = {
    personnelSummary: null,
    poolList: null,
};

export const PersonalSummaryReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_PERSONNEL_SUMMARY:
            return {
                ...state,
                personnelSummary: action.payload.data.resultObject,
            };

        case Types.SET_POOL_LIST:
            return {
                ...state,
                poolList: action.payload.resultObject,
            };

        default:
            return state;
    }
};
